import React from "react";
import { useLocation } from "react-router-dom";
import AgentWantAdForm from "../components/AgentWantAdForm";
import Loader from "../components/Common/Loader";
import { AGENT_WANTAD_KEY } from "@/constants/common";
import { getLocalStorage } from "@/helpers/common";
import { startFromId, useStartFromWantAd } from "@/hooks/useStartFromWantAd";

const AgentCreateWantAd = () => {
  const location = useLocation();
  const sourceId = location.state?.data ? null : startFromId(location.search);
  const startFrom = useStartFromWantAd(sourceId);

  if (sourceId && startFrom.isPending) {
    return <Loader />;
  }

  const initialData =
    location.state?.data ||
    // A requested copy that failed opens an empty form, not an unrelated
    // draft left in localStorage.
    (sourceId ? startFrom.data : getLocalStorage(AGENT_WANTAD_KEY));

  const isFromConfirmationPage =
    location.state?.isFromConfirmationPage === true;

  const isEdit = isFromConfirmationPage
    ? true
    : location.state?.data
      ? location.state.data.isEdit !== false
      : false;

  return <AgentWantAdForm initialData={initialData} isEdit={isEdit} />;
};

export default AgentCreateWantAd;
